import { Controller } from "@hotwired/stimulus";

let timeoutIds = [];

export default class extends Controller {
  static targets = ["quantity"];

  connect() {
    window.dataLayer = window.dataLayer || [];

    this.addProductToastTimeout = null;
  }

  setToastBaseInfo(name = "", imgSrc = "") {
    const toastImage = document.querySelector('.add-product_toast_product-img img');
    const toastProductName = document.querySelector('.add-product_toast_product-name');
    toastProductName.textContent = name;
    toastImage.src = imgSrc;
  }

  setToastPriceInfo(price = "", discountedPrice = "") {
    const toastProductPriceContainer = document.querySelector('.add-product_toast_product-price');
    if (toastProductPriceContainer) {
      toastProductPriceContainer.querySelector('.main-price').textContent = price;
      toastProductPriceContainer.querySelector('.discounted-price').textContent = discountedPrice;
    }
  }

  displayAddedProductToast() {
    const toastContainer = document.querySelector('.add-product_toast');
    
    this.setToastBaseInfo(this.element.dataset.itemName, this.element.dataset.itemImg)
    this.setToastPriceInfo(this.element.dataset.itemMainPrice, this.element.dataset.itemDiscountedPrice)

    toastContainer.classList.add('active');
    window.dxNavigation?.showHeader();

    if (this.addProductToastTimeout) {
      clearTimeout(this.addProductToastTimeout)
    }
    this.addProductToastTimeout = setTimeout(() => {
      toastContainer.classList.remove('active');
      this.addProductToastTimeout = null;
      this.setToastPriceInfo()
    }, 4500);
  }

  addToCart(e) {
    e.preventDefault();
    if (window.flatpickrInstances?.["header"]?.hasUser) {
      const flatpickrInstance = window.flatpickrInstances["header"]
      if (flatpickrInstance.instance.selectedDates?.length < 2) {
        flatpickrInstance.openToast();
        return
      }
    }

    let quantity = 1;

    if (this.hasQuantityTarget && this.quantityTarget instanceof HTMLInputElement) {
      quantity = +this.quantityTarget.value || 1;
    }
    this.submit(e.currentTarget.form, () => {
      this.displayAddedProductToast();
      const itemName = this.element.dataset.itemName;
      const itemId = this.element.dataset.itemId;
      const itemCategory = this.element.dataset.itemCategory;

      window.dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          items: [
            {
              item_name: itemName,
              item_id: itemId,
              item_category: itemCategory,
              quantity: quantity
            }
          ]
        }
      });
      this.changeIcon();
      const globalCartIcons = document.querySelectorAll('.livraison-animated');
      if (globalCartIcons.length > 0){
        timeoutIds.forEach((id) => clearTimeout(id))
        globalCartIcons.forEach((cartIcon) => {
          cartIcon.classList.add('animating')
          timeoutIds.push(setTimeout(() => cartIcon.classList.remove('animating'), 3050))
        });
      }
    });
  }

  changeIcon() {
    // Hide plus-box on product add. On the catalogue card the controller sits
    // on the hidden button, whose closest("div") is the card body that also
    // contains the plus-box; on the other (form-based) call sites the previous
    // resolution is preserved.
    let plusBox =
      this.element.closest("div").querySelector(".plus-box") ||
      this.element.closest("div").querySelector(".js-plus-box");
    if (!plusBox) return;
    plusBox.classList.add("added-to-truck");
    setTimeout(() => {
      plusBox.classList.remove("added-to-truck");
    }, 3000);
  }

  // Form-based call sites submit their <form>; the catalogue card button has
  // no form and carries its payload as data attributes instead (the markup of
  // a per-card form/turbo-frame was ~1.5 KB per card).
  submit(form, successCb) {
    if (form) {
      this.submitForm(form, successCb);
    } else {
      this.submitFromDataset(successCb);
    }
  }

  async submitForm(form, successCb) {
    const formData = new FormData(form);
    formData.set('add-camion', true)
    await this.postCart(form.action, form.method, formData, successCb);
  }

  async submitFromDataset(successCb) {
    const data = this.element.dataset;
    if (!data.addToCartUrl || !data.itemId) return;
    const body = new FormData();
    body.set("product_variant_cart[product_variant_id]", data.itemId);
    body.set("product_variant_cart[quantity]", "+1");
    body.set("product_variant_cart[include_default_accessories]", "true");
    body.set("add-camion", "true");
    await this.postCart(data.addToCartUrl, "post", body, successCb);
  }

  async postCart(url, method, body, successCb) {
    // The global token from the meta tag is accepted by Rails even with
    // per-form CSRF tokens enabled (valid_authenticity_token? checks both).
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
    const response = await fetch(url, {
      method: method,
      headers: csrfToken ? { "X-CSRF-Token": csrfToken } : {},
      body: body
    });

    if (response.ok) {
      successCb();
    }

    const html = await response.text()
    Turbo.renderStreamMessage(html)
  }
}
